declare const AMap: any;

export function ClusterBubble(options: any) {
    // AMap.CustomOverlay.call(this, options);
}

// ClusterBubble.prototype = new AMap.CustomOverlay();

ClusterBubble.prototype.onInit = function (options: any) {
    this.content = options.content;
    this.position = options.position;
    this.initDom();
};

ClusterBubble.prototype.initDom = function () {
    this.dom = document.createElement('div');
    this.dom.className = 'clusterBubble';
    this.dom.innerHTML = this.content;
    Object.assign(this.dom.style, {
        width: `${40 + parseInt(this.content) * 2}px`,
        height: `${40 + parseInt(this.content) * 2}px`,
        lineHeight: `${40 + parseInt(this.content) * 2}px`,
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center'
    });

    this.dom.addEventListener('click', () => {
        this.emit('click');
    });
};

ClusterBubble.prototype.emit = function (type: string) {
    if (this.events && this.events[type]) {
        this.events[type].forEach((cb: Function) => cb());
    }
};

ClusterBubble.prototype.onDestroy = function () {
    this.dom.remove();
};

ClusterBubble.prototype.setPosition = function (lnglat: any) {
    const px = this.map.lngLatToContainer(lnglat);
    this.dom.style.left = `${px.x}px`;
    this.dom.style.top = `${px.y}px`;
};

export interface AmapVM {
    map_dom: string;
    map: any;
    lat: number;
    lng: number;
    init: () => void;
}

class AmapAdapter implements AmapVM {
    public map_dom: string;
    public map: any;
    public lat: number;
    public lng: number;
    public zoom: number;
    public markers: any[] = [];
    public circles: any[] = [];
    public path: any[] = [];
    public polyline: any;

    public infoWindow: any = null;
    public markerCluster: any = null;

    constructor(dom: string = '', lng: number, lat: number, zoom: number = 4) {
        this.map_dom = dom;
        this.lat = lat;
        this.lng = lng;
        this.zoom = zoom;
        if (dom) this.init();
    }

    init() {
        this.map = new AMap.Map(this.map_dom, {
            zoom: this.zoom,
            center: [this.lng, this.lat],
            viewMode: '2D'
        });
        this.map.on('click', () => {
            if(this.infoWindow) {
                this.infoWindow.close();
                this.infoWindow = null;
            }
        });
    }

    destroy() {
        this.map.destroy();
    }

    getLngLat(lng: number, lat: number) {
        return new AMap.LngLat(lng, lat);
    }

    async getPoint(address: string) {
        return new Promise((resolve) => {
            AMap.plugin('AMap.Geocoder', () => {
                new AMap.Geocoder().getLocation(address, (status: string, result: any) => {
                    if (status === 'complete') resolve(result.geocodes[0].location);
                });
            });
        });
    }

    addMarker(config: any, width = 50, height = 50, x = -16, y = -32) {
        console.log("addMarker:",config)
        const icon = new AMap.Icon({
            image: config.icon,
            size: new AMap.Size(width, height),
            // imageOffset: new AMap.Pixel(x, y)
            imageOffset: new AMap.Pixel(0, 0)
        });
        const marker = new AMap.Marker({
            position: config.lnglat,
            icon: icon,
            // content: config.icon ? `<img src="${config.icon}" style="width:${width}px;height:${height}px"/>` : '',
            offset: new AMap.Pixel(x, y)
        });

        if (config.content) {
            marker.on('click', () => {
                this.infoWindow = new AMap.InfoWindow({
                    content: config.content,
                    offset: new AMap.Pixel(0, -24)
                });
                this.infoWindow.open(this.map, marker.getPosition());
            });
        }

        this.markers.push(marker);
        this.map.add(marker);
        return marker;
    }

    setZoomAndCenter(zoom: number, lnglat: any) {
        this.map.setZoomAndCenter(zoom, lnglat);
    }
    setMarkerClusterer(positions: any[]) {
        if (this.markerCluster) this.map.remove(this.markerCluster);

        const markers = positions.map(pos => new AMap.Marker({
            position: [pos.lng, pos.lat],
            content: '<div class="marker"></div>'
        }));

        this.markerCluster = new AMap.MarkerClusterer(this.map, markers, {
            gridSize: 60,
            renderCluster: (count: number, cluster: any) => {
                return new ClusterBubble({
                    map: this.map,
                    position: cluster.getBounds().getCenter(),
                    content: count
                });
            }
        });
    }

    addPolyline(path: any[]) {
        const polyline = new AMap.Polyline({
            path: path.map(p => [p.lng, p.lat]),
            strokeColor: '#4948fb',
            strokeWeight: 3
        });
        this.map.add(polyline);
    }

    // 其他方法类似替换为高德API实现...

    resetPath() {
        try {
            this.path = [];
            this.closeAllWindow();
            // this.clearAllOverlays();
            // this.clearPolyLine();
            const allOverlay = this.map.getAllOverlays(); // 获取所有覆盖物[3]
            for (let i = allOverlay.length - 1; i >= 0; i--) { // 反向遍历避免删除后索引错乱[3]
                const overlay = allOverlay[i];
                if (overlay instanceof AMap.Marker) { // 判断是否为标记点
                    this.map.remove(overlay);
                } else if (overlay instanceof AMap.Polyline) { // 判断是否为折线
                    this.map.remove(overlay);
                }
            }
            this.markers = [];
            const elements = document.querySelectorAll('.clusterBubble');
            elements.forEach(function (element) {
                element.parentNode.removeChild(element);
            });
            if (this.markerCluster) {
                this.markerCluster.setMap(null);
            }

        } catch (err) {}
    }
    clearAllOverlays() {
        var overlay;
        while ((overlay = this.markers.pop())) {
            overlay.setMap(null);
        }
    }
    clearPolyLine() {
        if (this.polyline) {
            this.polyline.setMap(null);
        }
    }
    closeAllWindow() {
        if (this.infoWindow) {
            this.infoWindow.close();
        }
    }
    // type 1 右下角 2左上角
    addMapControl(position='RB',x1=35,y1=45,x2=25,y2=10) {
        // 加载地图控件插件
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], () => {
            const toolbar = new AMap.ToolBar({
                position: position,  // LB=左下角，RB=右下角（默认）
                offset: [x1, y1]  // 位置微调
            });
            this.map.addControl(toolbar);

            const scale = new AMap.Scale({
                position: position,  // 对应左下角
                offset: [x2, y2] // 相对于缩放控件的垂直位置调整
            });
            this.map.addControl(scale);
        });
    }
}

export default AmapAdapter;